function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m11.769 9.458.035.562-.578-.068c-2.105-.264-3.943-1.16-5.503-2.663l-.763-.746-.197.551c-.416 1.228-.15 2.525.717 3.397.462.482.358.55-.44.264-.277-.092-.52-.16-.543-.126-.08.08.197 1.124.416 1.537.3.574.914 1.136 1.584 1.47l.567.263-.67.012c-.648 0-.671.011-.602.252.231.746 1.144 1.538 2.162 1.882l.717.241-.625.367a6.593 6.593 0 0 1-3.098.85c-.52.01-.948.057-.948.091 0 .115 1.41.758 2.231 1.01 2.463.746 5.388.425 7.584-.85 1.56-.906 3.122-2.707 3.85-4.452.393-.93.786-2.627.786-3.442 0-.528.035-.597.682-1.228.382-.367.74-.769.81-.884.115-.218.104-.218-.486-.023-.983.345-1.122.299-.636-.218.358-.367.786-1.032.786-1.227 0-.035-.173.023-.37.126-.208.115-.67.287-1.017.39l-.624.195-.567-.379c-.312-.206-.751-.436-.983-.505-.59-.16-1.49-.137-2.023.046-1.445.517-2.358 1.848-2.254 3.305z",
  fill: "#999",
  fillRule: "evenodd"
});

function SvgIco24FooterTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco24FooterTwitter);
export default __webpack_public_path__ + "static/media/ico_24_footer_twitter.6ab73db0.svg";
export { ForwardRef as ReactComponent };